<template>
  <div>
    <mdb-modal removeBackdrop centered @close="closeModal" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Existing Request</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">{{ sentence_1 }}</p>
        <p class="mb-4 mt-n3">{{ sentence_2 }}</p>
        <mdb-btn class="btn btn-isi-secondary" @click="closeModal">No</mdb-btn>
        <mdb-btn class="btn btn-isi" @click="handleYes">{{
          button_txt_1
        }}</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  created() {
    if (this.options.type == "add") {
      this.sentence_1 =
        "Adding this studio to your request list will prevent you from adding more options to your last request.";
      this.sentence_2 = "Do you still want to add the studio?";
      this.button_txt_1 = "Yes, add studio";
    } else if (this.options.type == "remove") {
      this.sentence_1 =
        "Removing this studio from your request list will prevent you from adding more options to your last request.";
      this.sentence_2 = "Do you still want to remove the studio?";
      this.button_txt_1 = "Yes, remove studio";
    }
  },
  data() {
    return {
      sentence_1: "",
      sentence_2: "",
      button_txt_1: "",
    };
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$store.commit("clearCurrentModal");
    },
    handleYes() {
      if (this.options.type == "add") {
        this.$http({
          method: "post",
          url: "/api/UserAction/AddRequestListItem",
          data: {
            testType: this.options.testType,
            testStudioId: this.options.testStudioId,
            overwriteRequest: true,
          },
        })
          .then(() => {
            this.$store.commit("addTestStudioToRequestList", {
              testStudioId: this.options.testStudioId,
            });
            this.closeModal();
          })
          .catch((err) => {
            this.$store.commit("setCurrentModal", {
              type: "GeneralInfoModal",
              options: {
                title: "Error",
                content: err.response.data,
              },
            });
          });
      } else if (this.options.type == "remove") {
        this.$http({
          method: "post",
          url: "/api/UserAction/RemoveRequestListItem",
          data: {
            testStudioId: this.options.testStudioId,
            overwriteRequest: true,
          },
        })
          .then(() => {
            this.$store.commit("removeTestStudioFromRequestList", {
              testStudioId: this.options.testStudioId,
            });
            this.closeModal();
          })
          .catch((err) => {
            this.$store.commit("setCurrentModal", {
              type: "GeneralInfoModal",
              options: {
                title: "Error",
                content: err.response.data,
              },
            });
          });
      }
    },
  },
};
</script>

<style>
</style>